// Permission codes — must match models/rbac.go constants in the Go API.
//
// Always reference these constants in JSX/route specs, never raw strings:
//
//   <Can perm={Perm.PolicyWrite}>...</Can>
//   { path: '/audit', perm: Perm.AuditRead }
//
// When adding a permission code: add it here AND in models/rbac.go,
// then update systemRoleGrants in handlers/rbac_seed.go for any role
// that should hold it.

export const Perm = {
  PolicyRead: 'policy.read',
  PolicyWrite: 'policy.write',
  PolicyDelete: 'policy.delete',
  DecisionRead: 'decision.read',
  DecisionWrite: 'decision.write',
  GroupRead: 'group.read',
  GroupWrite: 'group.write',
  UserRead: 'user.read',
  UserWrite: 'user.write',
  AgentEnroll: 'agent.enroll',
  AgentHeartbeat: 'agent.heartbeat',
  AuditRead: 'audit.read',
  TenantManage: 'tenant.manage',
  SettingsManage: 'settings.manage',
  RoleManage: 'role.manage',
} as const;

export type PermCode = typeof Perm[keyof typeof Perm];
